import { defineComponent, reactive, ref, watch, toRefs, onMounted, nextTick, onBeforeUnmount } from "vue";
import * as echarts from "echarts";
var color1 = ['rgb(255, 153, 153)', 'rgb(61, 186, 45)', 'rgb(255,222,0)', 'rgb(255,0,0)'];
var data = [];
var placeHolderStyle = {
  normal: {
    label: {
      show: false
    },
    labelLine: {
      show: false
    },
    color: 'rgba(0, 0, 0, 0)',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderWidth: 0
  }
};
export default defineComponent({
  components: {},
  name: "",
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    title: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: () => {}
    },
    color: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    let myEcharts = ref(null);
    let myChart = null;
    const state = reactive({
      option: null
    });
    const methods = reactive({});
    const setOptions = ({
      legend,
      series,
      xaxis
    } = {}) => {
      data = [];
      for (var i = 0; i < props.chartData.length; i++) {
        data.push({
          value: props.chartData[i].value,
          name: props.chartData[i].name,
          itemStyle: {
            normal: {
              borderWidth: 4,
              shadowBlur: 30,
              borderColor: color1[i],
              shadowColor: color1[i],
              color: color1[i],
              opacity: 1
            }
          }
        }, {
          value: 1,
          name: '',
          itemStyle: placeHolderStyle
        });
      }
      state.option = {
        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        series: [{
          name: '',
          type: 'pie',
          clockWise: false,
          radius: ['30%', '90%'],
          center: ['50%', '45%'],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          data: data
        }]
      };
      myChart.setOption(state.option);
    };
    onMounted(() => {
      nextTick(() => {
        myChart = echarts.init(myEcharts.value);
        setOptions();
      });
    });
    window.addEventListener('resize', () => {
      myChart.resize();
    });
    onBeforeUnmount(() => {
      destroy();
    });
    const destroy = () => {
      if (!myChart) {
        return;
      }
      myChart.dispose(); //销毁
    };
    watch(() => props.chartData, () => {
      if (myChart) {
        myChart.clear();
      }
      setOptions(props.chartData);
    }, {
      deep: true
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      setOptions,
      myEcharts,
      destroy
    };
  }
});